import React, { useEffect } from 'react'
import StudentSidebar from '../StudentSidebar/StudentSidebar'
import {
    CircularProgressbar,
    CircularProgressbarWithChildren,
    buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

// Animation
import { easeQuadInOut } from "d3-ease";
import AnimatedProgressProvider from "../../../utils/AnimatedProgressProvider";

import { Link } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useDispatch, useSelector } from 'react-redux'
import { getProfileData } from '../../../Redux/action/MasterAction';
import Beatloader from '../../../Common/BeatLoader';

const host = process.env.REACT_APP_API_SERVER
const StudentProfile = () => {

    const dispatch = useDispatch();
    const authToken = localStorage.getItem('student-token');
    useEffect(() => {
        dispatch(getProfileData(authToken))
    }, []);

    const {
        loadingProfileDataListApi,
        ProfileDataListApiData,
        ProfileDataListApiError,
    } = useSelector(state => state?.MasterReducer);



    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Profile
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            {loadingProfileDataListApi ?
                                <Beatloader />
                                :
                                <main className="px-3 bg-light">
                                    <div className="student-profile-sec px-3">
                                        <div className="row mb-5">
                                            <div className="col-lg-12 d-flex justify-content-end mt-3">
                                                <Link to="/student/profile-update">
                                                    <button className="btn btn-primary me-3 px-3">
                                                        <i className="bi bi-pencil-square me-1" />
                                                        Edit
                                                    </button>
                                                </Link>
                                            </div>
                                            <div className="col-lg-12 mb-2 w-100 d-flex justify-content-center">
                                                <div className="profile-top-sec w-50">
                                                    <div className="profile-top-img d-flex justify-content-center">
                                                        <OverlayTrigger

                                                            placement='right'
                                                            overlay={
                                                                <Tooltip className='bg-light'>
                                                                    {ProfileDataListApiData?.profile_status_percentage}%
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <div className="img-sec position-relative">
                                                                {/* Circular Progress Bar */}
                                                                <AnimatedProgressProvider
                                                                    valueStart={0}
                                                                    valueEnd={ProfileDataListApiData?.profile_status_percentage}
                                                                    duration={1.4}
                                                                    easingFunction={easeQuadInOut}

                                                                >
                                                                    {value => {
                                                                        const roundedValue = Math.round(value);
                                                                        return (
                                                                            <CircularProgressbar
                                                                                value={value}
                                                                                styles={buildStyles({ pathTransition: "none" })}
                                                                            />
                                                                        );
                                                                    }}
                                                                </AnimatedProgressProvider>
                                                                {/* Profile Image */}
                                                                <img
                                                                    src={`${host}${ProfileDataListApiData?.data?.profile_img}`}

                                                                    onError={(e) => {
                                                                        e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                                    }}
                                                                    className="profile-img w-auto"
                                                                />
                                                            </div>
                                                        </OverlayTrigger>
                                                    </div>
                                                    <h4 className="text-center mt-3">{ProfileDataListApiData?.data?.name}</h4>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="row mb-5">
                                        <div className="col-lg-6 mb-3">
                                            <label htmlFor="">Student Name</label>
                                            <div className="card input-form">
                                                <div className="card-body p-1">
                                                    <p className="mb-0">{ProfileDataListApiData?.data?.name}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label htmlFor="">Phone Number</label>
                                            <div className="card input-form">
                                                <div className="card-body p-1">
                                                    <div className="d-flex justify-content-start">
                                                        {/* <div className="col-lg-3 border-end"> */}
                                                            <p className="mb-0">
                                                                {ProfileDataListApiData?.data?.country_code}-{ProfileDataListApiData?.data?.mobile}

                                                            </p>
                                                        {/* </div> */}
                                                        {/* <div className="col-lg-9"> */}
                                                            {/* <p className="mb-0">{ProfileDataListApiData?.data?.mobile}</p> */}
                                                        {/* </div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label htmlFor="">Email Id</label>
                                            <div className="card input-form">
                                                <div className="card-body p-1">
                                                    <p className="mb-0">{ProfileDataListApiData?.data?.email}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label htmlFor="">Date of Birth</label>
                                            <div className="card input-form">
                                                <div className="card-body p-1">
                                                    <div className="row">
                                                        <div className="col-lg-10 col-md-10 col-10">
                                                            <p className="mb-0">{ProfileDataListApiData?.data?.dob}</p>
                                                        </div>
                                                        <div className="col-lg-2 col-md-2 col-2 d-flex justify-content-end">
                                                            <i className="fa-solid fa-calendar-days" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label htmlFor="">Gender</label>
                                            <div className="card input-form">
                                                <div className="card-body p-1">
                                                    <div className="row">
                                                        <div className="col-lg-10 col-md-10 col-10">
                                                            <p className="mb-0">{ProfileDataListApiData?.data?.gender}</p>
                                                        </div>
                                                        <div className="col-lg-2 col-md-2 col-2 d-flex justify-content-end">

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label htmlFor="">Zipcode</label>
                                            <div className="card input-form">
                                                <div className="card-body p-1">
                                                    <div className="row">
                                                        <div className="col-lg-10 col-md-10 col-10">
                                                            <p className="mb-0">{ProfileDataListApiData?.data?.zip_code}</p>
                                                        </div>
                                                        <div className="col-lg-2 col-md-2 col-2 d-flex justify-content-end">

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label htmlFor="">Address Line-1</label>
                                            <div className="card input-form">
                                                <div className="card-body p-1">
                                                    <p className="mb-0">{ProfileDataListApiData?.data?.address_line_1}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label htmlFor="">Address Line-2</label>
                                            <div className="card input-form">
                                                <div className="card-body p-1">
                                                    <p className="mb-0">{ProfileDataListApiData?.data?.address_line_2}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label htmlFor="">Country</label>
                                            <div className="card input-form">
                                                <div className="card-body p-1">
                                                    <div className="row">
                                                        <div className="col-lg-10 col-md-10 col-10">
                                                            <p className="mb-0">{ProfileDataListApiData?.data?.countries?.name}</p>
                                                        </div>
                                                        <div className="col-lg-2 col-md-2 col-2 d-flex justify-content-end">

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label htmlFor="">State</label>
                                            <div className="card input-form">
                                                <div className="card-body p-1">
                                                    <div className="row">
                                                        <div className="col-lg-10 col-md-10 col-10">
                                                            <p className="mb-0">{ProfileDataListApiData?.data?.states?.name}</p>
                                                        </div>
                                                        <div className="col-lg-2 col-md-2 col-2 d-flex justify-content-end">

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label htmlFor="">City</label>
                                            <div className="card input-form">
                                                <div className="card-body p-1">
                                                    <div className="row">
                                                        <div className="col-lg-10 col-md-10 col-10">
                                                            <p className="mb-0">{ProfileDataListApiData?.data?.cities?.name}</p>
                                                        </div>
                                                        <div className="col-lg-2 col-md-2 col-2 d-flex justify-content-end">

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </main>
                            }

                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default StudentProfile